<template>
    <div class="card-container" v-if="student">
        <v-row>
            <v-col cols="4">
                <div class="student-img" :style="`background-image: url(${studentImg})`"/>
            </v-col>
            <v-col cols="8">
                <div class="student-name text-truncate">
                    {{ student.name }}
                </div>
                <div class="student-info text-truncate">
                    {{ studentGroup }}
                </div>
                <div class="student-info text-truncate">
                    {{ studentObjectives }}
                </div>
                <div class="student-info text-truncate">
                    {{ student.email }}
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import {db} from "@/utils/Firebase";

export default {
    name: "CoachStudentCard",
    props: {
        student: {
            type: Object,
            default: null,
        }
    },
    data(vm) {
        return {
            studentGroup: vm.$t('common.no_group_team')
        }
    },
    computed: {
        studentImg(vm = this) {
            if (!vm.student.avatar) return vm.imgPlaceholder
            return vm.student.avatar
        },
        studentObjectives(vm = this) {
            if (!vm.student.objectives || vm.student.objectives.length === 0) return vm.$t('common.no_objectives')
            return vm.student.objectives.join(', ')
        },
    },
    async mounted() {
        const vm = this
        await vm.loadTeamGroup()
    },
    methods: {
        async loadTeamGroup() {
            const vm = this
            vm.studentGroup = vm.$t('common.loading')
            if (!vm.student.group && !vm.student.team) return vm.studentGroup = vm.$t('common.no_group_team')
            if (vm.student.group) {
                let ref = await db.collection('groups').doc(vm.student.group).get()
                vm.studentGroup = ref.data().name
            }
            if (vm.student.team?.id) {
                let ref = await db.collection('teams').doc(vm.student.team.id).get()
                vm.studentGroup = ref.data() && ref.data().groups.find(group => group.id === vm.student.team.subgroupId)?.name || vm.$t('common.no_group_team')
            }
        }
    }
}
</script>

<style scoped>

.card-container {
    background: #FFFFFF;
    border-radius: 4px;
    padding: 12px 10px;
}

.student-img {
    border-radius: 14px;
    height: 100%;
    background-color: rgba(51, 51, 51, .1);
    background-position: center;
    background-size: cover;
}

.student-name {
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    color: #333333;
}

.student-info {
    font-weight: 300;
    font-size: 13px;
    line-height: 16px;
    color: #333333;
}

</style>